import { apiClient } from 'pobble-components/dist/api'
import { getPobbleEnv } from 'pobble-components/dist/utils'

const ENV = getPobbleEnv()
const ORIGIN = window.location.origin

const o365ClientIds = {
  local: '1749949a-c377-4940-b48b-bf75a3cad298',
  stg: '5d475c26-be96-4a9d-bf49-5fa06292de57',
  prod: '3f112eef-0a91-4b02-9a1f-dc20cfe1e68d'
}

const apiO365Authentication = (data, params) =>
  apiClient.post('v3/o365_authentication', data, { params })

const apiO365ConnectIdentity = (data, params) =>
  apiClient.post('/v3/o365_authentication/connect_oauth_identity', data, {
    params
  })

const getCallbackUrl = spa =>
  ENV === 'local'
    ? 'http://localhost:3001/oauth-callback/o365'
    : `${ORIGIN}/${spa}/oauth-callback/o365`

const startO365LoginProcess = spa =>
  Promise.resolve(
    (window.location = window.encodeURI(
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${
        o365ClientIds[ENV]
      }&response_type=code&redirect_uri=${getCallbackUrl(
        spa
      )}&response_mode=query&scope=openid offline_access https://graph.microsoft.com/user.read https://graph.microsoft.com/mail.read`
    ))
  )

const o365Callback = (params, spa) => {
  return new Promise((resolve, reject) => {
    if (params.error) return reject('CANCEL')
    apiO365Authentication(
      {
        code: params.code,
        callback_url: getCallbackUrl(spa)
      },
      {
        include: 'account.finish_signup_status'
      }
    )
      .then(resolve)
      .catch(reject)
  })
}

const o365ConnectCallback = (params, spa) => {
  return new Promise((resolve, reject) => {
    if (params.error) return reject('CANCEL')
    apiO365ConnectIdentity({
      code: params.code,
      callback_url: getCallbackUrl(spa)
    })
      .then(resolve)
      .catch(reject)
  })
}

export { startO365LoginProcess, o365Callback, o365ConnectCallback }
